/**
 * Звонок с телефона (DEV-2493): номер открывает звонилку устройства. Браузерный
 * софтфон на телефоне — это запрос микрофона, регистрация SIP и webrtc/key
 * (1–2 с) на каждом открытии карточки, а звонилка у менеджера и так в руке.
 */

/**
 * Телефон: основной указатель — палец, и экран узкий. Планшет сюда не попадает:
 * на Wi-Fi-iPad tel: звонит только через сопряжённый iPhone, а софтфон там работает.
 * Тачскрин ноутбука — тоже нет: основной указатель у него мышь или тачпад.
 */
export const isPhone = (): boolean =>
  (window.matchMedia?.('(pointer: coarse)').matches ?? false) &&
  Math.min(window.screen.width, window.screen.height) < 600

/** Второй номер или добавочный: «, …», «; …», «/ …», «доб.», «доп.», «ext», «x 12», «#12», «или». */
const SECOND_PART = /[,;/#]|доб|доп|ext|\sили\s|(?:^|\s)x(?=\s*\d)/i

/**
 * tel:-ссылка на первый номер строки: звонилке нужны только цифры и «+». Второй
 * номер и добавочный отрезаем — иначе цифры склеились бы в чужой номер. «+»
 * сохраняем, даже если перед ним подпись («моб. +7…», «(+84) …»): без него
 * номер с вьетнамской SIM наберётся неверно. Меньше 5 или больше 15 цифр (предел
 * E.164 — значит, склеились два номера) — не номер: ссылки нет ('').
 */
export const telHref = (phone: string): string => {
  const first = phone.split(SECOND_PART)[0] ?? ''
  const digits = first.replace(/\D/g, '')
  if (digits.length < 5 || digits.length > 15) return ''
  return `tel:${/\+\s*\(?\s*\d/.test(first) ? '+' : ''}${digits}`
}

/** Открывает звонилку устройства с номером; false — номер не набрать. */
export const dialOnDevice = (phone: string): boolean => {
  const href = telHref(phone)
  if (href) window.location.href = href
  return Boolean(href)
}
